import { render, staticRenderFns } from "./classical-material.vue?vue&type=template&id=56c45366"
import script from "./classical-material.vue?vue&type=script&lang=js"
export * from "./classical-material.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports